// DEBT customization — T3.4 página do board. Mapa de aparência das pastilhas
// de condição transversal (PRD secao 2: "aparecem como pastilhas no card,
// nunca como coluna"). Os quatro valores espelham DEBT_STATES em
// useDebtStateFeedback.js — não reinventa a lista, e reusa as MESMAS chaves
// de tradução (CONVERSATION.DEBT_STATE_WIDGET.STATES.*) para não duplicar
// rótulo.
//
// Classes fixadas em `text-n-*-12` (não `-11`): a lição já paga nesta
// unidade (Select.vue com `outline-n-red-9` inerte; SLA alert do widget
// T3.3 em `text-n-amber-12` porque `-11` reprova WCAG 1.4.3 no claro) foi
// medida para DUAS escalas (slate, amber) e as DUAS falharam em `-11`. Sem
// medição própria das outras escalas aqui (axe não roda neste pacote — ver
// RISCOS do retorno da unidade), usar a mesma margem de segurança em todas
// é a escolha defensável, não a mais bonita.
export const DEBT_STATE_PILL_CONFIG = {
  ESTAGNADO: {
    icon: 'i-lucide-clock-alert',
    classes: 'bg-n-amber-3 text-n-amber-12',
  },
  SRETORNO: {
    icon: 'i-lucide-mail-question',
    classes: 'bg-n-blue-3 text-n-blue-12',
  },
  CONCLUIDA: {
    icon: 'i-lucide-circle-check',
    classes: 'bg-n-teal-3 text-n-teal-12',
  },
  LIXO: { icon: 'i-lucide-trash-2', classes: 'bg-n-ruby-3 text-n-ruby-12' },
};

export const SLA_BREACHED_PILL = {
  icon: 'i-lucide-triangle-alert',
  classes: 'bg-n-amber-3 text-n-amber-12',
};
